import { render, staticRenderFns } from "./PrinterStatus.vue?vue&type=template&id=1bce6b4f&scoped=true"
import script from "./PrinterStatus.vue?vue&type=script&lang=js"
export * from "./PrinterStatus.vue?vue&type=script&lang=js"
import style0 from "./PrinterStatus.vue?vue&type=style&index=0&id=1bce6b4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bce6b4f",
  null
  
)

export default component.exports